import { useApi } from '@/api';
import { TableSkeleton, Link } from '@/components';
import {
  useTableProps,
  CurrencyValue,
  PercentageValue,
  formatNumber,
  DataTable
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function ParametersTable() {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-dai',
    filtersDebounceTime: 50,
    initialFilters: { active: '0' }
  });

  const [data, error] = useApi({
    url: `/ilk-parameters/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Name',
        getCell: (row) => row.ilk
      },
      {
        header: 'DAI',
        getCell: (row) => formatNumber(row.dai),
        sortingField: 'dai',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Debt ceiling',
        getCell: (row) => formatNumber(row.debt_ceiling),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'DC IAM line',
        getCell: (row) => formatNumber(row.dc_iam_line),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'DC IAM gap',
        getCell: (row) => formatNumber(row.dc_iam_gap),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'DC IAM ttl',
        getCell: (row) =>
          formatNumber(row.dc_iam_ttl, { notation: 'standard' }) + ' sec',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'LR',
        getCell: (row) => <PercentageValue value={row.lr} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'TVL',
        getCell: (row) => (
          <CurrencyValue value={row.locked} options={{ currency: 'USD' }} />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Stability fee',
        getCell: (row) => <PercentageValue value={row.duty} />,
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'OSM price',
        getCell: (row) => (
          <CurrencyValue
            value={row.osm_price}
            options={{
              currency: 'USD'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      },
      {
        header: 'Dust',
        getCell: (row) => formatNumber(row.dust),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        rowLinkProps={{
          to: (row) => `/collateral/${row.group}/${row.ilk}/parameters`,
          // @ts-ignore
          linkComponent: Link
        }}
        columns={columns}
        getKey={(row) => row.ilk}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton rows={10} />;
}
